import { ICheckboxFieldProps } from './BaseInputField/BaseInputField.types';
import CheckboxField from './InputTypes/CheckboxField';

const KeepNumberAgreementInput = (props: ICheckboxFieldProps) => {
    return (
        <CheckboxField
            {...props}
            required
            name='KeepNumberAgreement'
            dataTestid='keep-number-checkbox'
            label={
                <span>
                    Your current communications provider may charge an Early Termination Fee (ETF)
                    or Installment Payoff if your service number has a Service Contract still active
                    OR if your service number is associated with a Device Installment Plan with a
                    current balance.
                </span>
            }
        />
    );
};

export default KeepNumberAgreementInput;
